










import { defineComponent, watch } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import UserAvatarController from "@/components/UserPictures/UserAvatarController";

export default defineComponent({
  name: "UserAvatar",
  components: { UserAvatarController },
  setup(_, { emit }) {
    const { authUserStrict } = useAuthUser();

    watch(
      authUserStrict,
      () => {
        emit("setValid", authUserStrict.value.avatar !== null || authUserStrict.value.avatarNsfw !== null);
      },
      { immediate: true }
    );

    return {
      authUserStrict,
    };
  },
});
